import { MembershipManager } from "@/components/shared/membership";
import { brandMembershipService } from "@/lib/services";
import type { RoleOption } from "@/types";

const ROLE_OPTIONS: RoleOption[] = [
  { value: "admin", label: "Admin", description: "Edit + manage access" },
  { value: "editor", label: "Editor", description: "Edit brand kit" },
  { value: "viewer", label: "Viewer", description: "Generate with brand" },
];

/** Membership access management for a brand. */
export function BrandAccessTab({ brandUuid }: Readonly<{ brandUuid: string }>) {
  return (
    <MembershipManager
      service={brandMembershipService}
      entityUuid={brandUuid}
      roleOptions={ROLE_OPTIONS}
      description="Admins can edit the brand and manage access. Editors can edit its kit and metadata. Viewers can generate with it."
      loadErrorLabel="Failed to load brand access"
      listScrollClass="max-h-64 overflow-y-auto"
    />
  );
}
